// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-text {
  transition: all 3s !important;
  font-size: 14px !important;
}

:root {
  /* ── Core Brand ── */
  --sidebar-bg-color: #FAFAFA;
  --sidebar-bg-color-rgb: 26, 26, 26;
  --btn-bg-primary: #1a1a1a;
  --btn-bg-primary-rgb: 26, 26, 26;
  --bg-btn-hover: #000000;
  --bg-btn-hover-rgb: 0, 0, 0;

  /* ── Surface Colors ── */
  --primary-bg-color: #FAFAFA;
  --primary-bg-color-rgb: 244, 246, 248;
  --secondary-bg-color: #ffffff;
  --secondary-bg-color-rgb: 255, 255, 255;

  /* ── Text ── */
  --primary-text-color: #1a1a1a;
  --primary-text-color-rgb: 26, 26, 26;
  --table-text-color: #6d7175;
  --table-text-color-rgb: 109, 113, 117;

  /* ── Borders ── */
  --border-color: #e1e3e5;
  --border-color-rgb: 225, 227, 229;
  --focus-border-color: #5c5f62;
  --focus-border-color-rgb: 92, 95, 98;

  /* ── Focus / Tabs ── */
  --focus-tab-color: #f1f2f3;
  --focus-tab-color-rgb: 241, 242, 243;

  /* ── Shadows ── */
  --shadow-card: 0 1px 3px 0 rgba(0, 0, 0, 0.06), 0 1px 2px -1px rgba(0, 0, 0, 0.04);
  --shadow-popover: 0 10px 20px -4px rgba(0, 0, 0, 0.10), 0 4px 6px -2px rgba(0, 0, 0, 0.05);

  /* ── Radius ── */
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;

  /* ── Font ── */
  --font-sans: 'Inter', 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

  /* ── Status Colors ── */
  --color-success: #008060;
  --color-success-bg: #e3f1ec;
  --color-warning: #b98900;
  --color-warning-bg: #fdf3d7;
  --color-danger: #d72c0d;
  --color-danger-bg: #fce8e6;
  --color-info: #0070c4;
  --color-info-bg: #e8f4fd;

  --tawk-header-background-color: var(--sidebar-bg-color);
  --tawk-header-background-color-rgb: var(var(--sidebar-bg-color-rgb));
}

.dark-mode {
  --sidebar-bg-color: #0d0d0d;
  --sidebar-bg-color-rgb: 13, 13, 13;
  --primary-bg-color: #1a1a1a;
  --primary-bg-color-rgb: 26, 26, 26;
  --secondary-bg-color: #242424;
  --secondary-bg-color-rgb: 36, 36, 36;
  --primary-text-color: #e3e3e3;
  --primary-text-color-rgb: 227, 227, 227;
  --border-color: #3a3a3a;
  --border-color-rgb: 58, 58, 58;
  --table-text-color: #9ca3af;
  --table-text-color-rgb: 156, 163, 175;
  --focus-border-color: #6b7280;
  --focus-border-color-rgb: 107, 114, 128;
  --focus-tab-color: #2e2e2e;
  --focus-tab-color-rgb: 46, 46, 46;
  --shadow-card: 0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 1px 2px -1px rgba(0, 0, 0, 0.2);
  --shadow-popover: 0 10px 20px -4px rgba(0, 0, 0, 0.45), 0 4px 6px -2px rgba(0, 0, 0, 0.3);
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
textarea:-webkit-autofill:active,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus,
select:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px var(--secondary-bg-color) inset !important;
  -webkit-text-fill-color: var(--primary-text-color) !important;
  caret-color: var(--primary-text-color) !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

.close.sidebar .menu-text {
  display: none;
  transition: all 3s !important;
}

.close-btn {
  width: 25px;
  height: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(var(--primary-bg-color-rgb), 70%);
  color: var(--table-text-color);
  transition: all 0.3s;
  border-radius: 4px;
  border: none;
  outline: none;
}

.close-btn:hover {
  background-color: var(--primary-bg-color);
  color: var(--primary-text-color);
}

/* .min-w-\\[240px\\] .sidebar .menu-text {
    display: block;
} */

.react-datepicker__input-container input {
  background-color: var(--secondary-bg-color) !important;
  color: var(--primary-text-color);
  border-color: var(--border-color) !important;
}

.menu-item,
.menu-item-close {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  z-index: 1;
  font-weight: 500 !important;
  overflow: hidden;
  transition: all 0.3s;
  font-size: 14px !important;
  padding: 9px !important;
  background-color: transparent;
}

.menu-arrow:hover {
  background-color: rgba(250, 249, 246, 10%);
  /* opacity: 10%; */
}

.tawk-button {
  background-color: var(--sidebar-bg-color) !important;
}

.status-bedge {
  padding: 4px 12px !important;
  border: 1px solid;
  position: relative;
  display: inline-block;
  border-radius: 30px;
  font-weight: 500;
  font-size: 12px;
  text-transform: capitalize;
}

.menu-item-close {
  color: #c9c8c8 !important;
}

.dark-mode .menu-item-close {
  color: var(--table-text-color) !important;
}

.menu-item-close:hover {
  color: white !important;
}

.out-of-stock {
  background-color: #fee2e2;
  color: #ef4444;
}

.dark-mode .out-of-stock {
  color: #fee2e2;
  background-color: rgb(211, 66, 66);
}

.in-stock {
  background-color: #dcfce7;
  color: #16a34a;
}

.dark-mode .in-stock {
  background-color: #16a34a;
  color: #dcfce7;
}

.yellow {
  background-color: #fef9c3;
  color: #ca8a04;
}

.dark-mode .yellow {
  color: #222222;
  background-color: #ecb745;
}

.menu-item span,
.menu-item-close span {
  font-size: 14px;
  font-weight: 500 !important;
  /* letter-spacing: 0.5s !important; */
}

.menu-item::after,
.menu-item-close::after {
  content: '';
  width: 100% !important;
  height: 100% !important;
  background-color: #faf9f6;
  opacity: 10% !important;
  opacity: 1;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  transition: all 0.3s;
  border-radius: 6px 5px 5px 6px !important;
}

.fixed-sidebar .menu-item::after,
.fixed-sidebar .menu-item-close::after {
  background-color: #faf9f6;
  opacity: 10%;
}

.dark-mode .menu-item::after,
.dark-mode .menu-item-close::after,
.dark-mode .fixed-sidebar .menu-item::after,
.dark-mode .fixed-sidebar .menu-item-close::after {
  background-color: var(--primary-bg-color) !important;
}

/* .menu-item::before,
.menu-item-close::before {
    content: '';
    width: 2px;
    height: 100%;
    background-color: white;
    border-radius: 10px;
    position: absolute;
    left: 0;
    top: 0;
    transition: all 0.3s;
} */
.fixed-sidebar .menu-item-close::after,
.fixed-sidebar .menu-item-close::before {
  color: #faf9f6;
}

.dark-mode .fixed-sidebar .menu-item-close::after,
.dark-mode .fixed-sidebar .menu-item-close::before,
.dark-mode .menu-item-close::after,
.dark-mode .menu-item-close::before {
  color: var(--table-text-color) !important;
}

.menu-item-close::after {
  opacity: 0;
  color: #faf9f6 !important;
  background-color: transparent !important;
}

.menu-item-close::before {
  top: 100%;
  color: #faf9f6 !important;
}

/* select {
  appearance: none;
  padding: 8px 30px 8px 12px !important;
  font-size: 14px !important;
  border-radius: 4px !important;
  border: 1px solid var(--border-color);
  border-color: var(--border-color) !important;
  cursor: pointer !important;
  outline: none !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  background-color: var(--secondary-bg-color) !important;
} */

.live-editor select {
  appearance: none;
}

.filterType select {
  cursor: auto;
}

.filter {
  min-width: 300px !important;
}

select:focus {
  border: 1px solid #6b7280 !important;
}

.adminseacrh select {
  border: none;
  padding: 8px 10px;
}

.adminseacrh select:focus {
  border: none;
}

/* input[type='text'],
input[type='number'],
input[type='Number'],
input[type='email'],
input[type='password'],
input[type='tel'],
textarea {
  padding: 8px 12px !important;
  font-size: 14px !important;
  line-height: 20px !important;
  border-radius: 4px !important;
  font-weight: 400 !important;
  box-shadow: none !important;
  outline: none !important;
  /* background: transparent !important 
  /* background-color: var(--secondary-bg-color) ; 
} */

.pos-input input[type='text'],
.pos-input input[type='number'],
.pos-input input[type='Number'],
.pos-input input[type='email'],
.pos-input input[type='password'],
.pos-input textarea {
  padding: 6px 12px !important;
}

.editor-title input[type='text'],
.editor-title input[type='number'],
.editor-title input[type='Number'],
.editor-title input[type='email'],
.editor-title input[type='password'],
.editor-title textarea {
  font-size: 12px !important;
}

/* ── Global Input & Textarea Placeholder Standardization ── */
input::placeholder,
textarea::placeholder {
  color: var(--table-text-color) !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  opacity: 1 !important;
}

.bg input {
  /* padding: 12px 12px !important; */
  font-size: 15px !important;
}

.bg button:not(.MuiButtonBase-root) {
  padding: 10px 20px !important;
}

.bg .autocomplete .MuiFormControl-root .MuiInputBase-root {
  padding: 13px 35px 13px 12px !important;
}

.MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track {
  background-color: var(--btn-bg-primary) !important;
}

/* input[type=checkbox] {
    position: relative;
    cursor: pointer;
} */

.MuiButtonBase-root.MuiCheckbox-root input[type='checkbox'] {
  position: absolute;
}

.MuiButtonBase-root.MuiCheckbox-root .MuiSvgIcon-root {
  width: 19px !important;
  height: 19px !important;
  font-weight: 400;
}

.MuiButtonBase-root.MuiCheckbox-root:hover {
  background-color: transparent !important;
}

.dark-mode input[type='text'],
.dark-mode input[type='file'],
.dark-mode input[type='number'],
.dark-mode input[type='Number'],
.dark-mode input[type='email'],
.dark-mode input[type='password'],
.dark-mode textarea {
  background-color: transparent !important;
  color: var(--table-text-color);
}

.file-tag-hover {
  border: 2px dashed rgba(var(--sidebar-bg-color-rgb), 30%) !important;
  background-color: rgba(var(--primary-bg-color-rgb), 70%) !important;
  transition: all 0.3s !important;
}

.dark-mode .file-tag-hover {
  border: 2px dashed var(--border-color) !important;
}

.file-tag-hover:hover {
  background-color: rgba(var(--primary-bg-color-rgb), 90%) !important;
  border-color: rgba(var(--sidebar-bg-color-rgb), 60%) !important;
}

.dark-mode .file-tag-hover:hover {
  background-color: var(--primary-bg-color);
}

.dark-mode select {
  background-color: var(--secondary-bg-color);
  color: var(--table-text-color);
}

.ql-container.ql-snow,
.ql-toolbar.ql-snow {
  border-color: var(--border-color) !important;
}

.ql-snow .ql-stroke,
.ql-snow .ql-picker,
.ql-snow .ql-fill,
.ql-editor.ql-blank::before,
.ql-editor {
  stroke: var(--table-text-color) !important;
  color: var(--table-text-color) !important;
  /* background-color: var(--secondary-bg-color) !important; */
}

.MuiRating-icon.MuiRating-iconEmpty {
  color: var(--table-text-color) !important;
}

.apexcharts-text.apexcharts-xaxis-label,
.apexcharts-text.apexcharts-yaxis-label {
  fill: var(--table-text-color) !important;
}

input[type='text']:focus,
input[type='number']:focus,
input[type='Number']:focus,
input[type='email']:focus,
input[type='password']:focus,
textarea:focus {
  border-color: #454545 !important;
}

input[type='date'] {
  padding: 8px 12px !important;
  font-size: 14px !important;
  line-height: 20px !important;
  border-radius: 4px !important;
  font-weight: 400 !important;
  cursor: pointer !important;
}

/* .select-arrow {
  position: absolute;
  top: 50%;
  right: 14px;
  z-index: 5 !important;
  transform: translateY(-50%);
  border-top: 5px solid var(--table-text-color);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
} */

summary {
  cursor: pointer !important;
}

.data-form {
  border-radius: 4px;
  background-color: var(--secondary-bg-color) !important;
  border: 1px solid var(--border-color) !important;
  padding: 30px;
  margin: 0 auto;
}

form label {
  display: block;
  color: var(--table-text-color);
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 4px;
  text-transform: capitalize !important;
}

.MuiRating-root label {
  font-size: 25px !important;
  color: inherit !important;
}

.rdt_TableHeader {
  border-bottom: 1px solid var(--border-color) !important;
}

.autocomplete .MuiFormControl-root .MuiInputBase-root {
  padding: 6px 35px 6px 12px !important;
  /* background-color: var(--secondary-bg-color); */
}

.MuiPaper-root.MuiPaper-elevation,
.MuiAutocomplete-noOptions,
.MuiPaper-root.MuiPaper-elevation>div {
  /* background-color: var(--secondary-bg-color) !important; */
  color: var(--table-text-color) !important;
}

.dark-mode .MuiPaper-root,
.dark-mode .MuiPopover-paper {
  background-color: var(--secondary-bg-color) !important;
  color: var(--primary-text-color) !important;
}

@media (max-width: 767px) {
  .MuiPaper-root.MuiPaper-elevation>div {
    /* background-color: var(--sidebar-bg-color) !important; */
    color: var(--table-text-color) !important;
  }
}

.live-editor-responsive .MuiPaper-root.MuiPaper-elevation {
  max-height: 90% !important;
}

.MuiSvgIcon-root {
  fill: var(--table-text-color) !important;
}

.dark-mode .autocomplete .MuiFormControl-root .MuiInputBase-root {
  background-color: transparent !important;
  color: var(--table-text-color);
}

.autocomplete .MuiFormControl-root .MuiInputBase-root .MuiOutlinedInput-notchedOutline,
.productLaunch .MuiFormControl-root .MuiInputBase-root .MuiOutlinedInput-notchedOutline {
  border-color: var(--border-color) !important;
  border-radius: 4px;
}

.autocomplete .MuiFormControl-root .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  /* border-color: black !important; */
  border: 1px solid #454545 !important;
  outline: none !important;
}

.autocomplete .MuiFormControl-root .MuiInputBase-root .MuiInputBase-input {
  padding: 0 !important;
  line-height: 20px !important;
  font-size: 14px !important;
  color: var(--table-text-color);
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  border-radius: 8px !important;
}

.autocomplete .MuiFormControl-root .MuiAutocomplete-selected-value {
  text-overflow: ellipsis !important;
}

.autocomplete .MuiFormControl-root .MuiInputBase-root input::placeholder {
  color: var(--table-text-color) !important;
}

.productLaunch .MuiStack-root {
  padding: 0;
  overflow: hidden;
}

.contryCode .MuiFormControl-root .MuiInputBase-root .MuiOutlinedInput-notchedOutline {
  border-radius: 4px 0 0 4px !important;
  border-right: none;
}

.contryCode input {
  border-radius: 0px 4px 4px 0 !important;
  /* border-left: none; */
}

.phone-input-container {
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid var(--border-color, #e5e5e5);
  background-color: var(--secondary-bg-color, #ffffff);
  border-radius: 8px;
  height: 36px;
  overflow: hidden;
  transition: border-color 150ms ease;
}

.phone-input-container:focus-within {
  border-color: var(--focus-border-color, #a3a3a6);
}

.phone-input-container .react-select__control {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  height: 34px !important;
  min-height: 34px !important;
  border-radius: 0 !important;
}

.phone-input-container .react-select__control:hover {
  border: none !important;
}

.back-arrow {
  width: 45px;
  height: 45px;
  background-color: transparent;
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  border-radius: 100%;
}

.back-arrow:hover {
  background-color: var(--secondary-bg-color);
}

.headerMenu .headerMenuBtn {
  opacity: 0;
  transition: all 0.3s;
}

.headerMenu {
  transition: all 0.3s;
}

.headerMenu:hover .headerMenuBtn,
.headerMenu:hover {
  opacity: 1;
  color: var(--primary-text-color) !important;
  background-color: var(--primary-bg-color) !important;
}

.menu-hover,
.acc-hover {
  position: relative;
}

.menu-hover .menu-dropdown,
.acc-hover .acc-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  opacity: 0;
  height: auto;
  visibility: hidden;
  z-index: 20;
  transition: all 0.2s;
}

.menu-hover .menu-dropdown {
  left: 0 !important;
}

.header:hover .acc-dropdown {
  opacity: 0;
  visibility: hidden;
}

.menu-hover:hover .menu-dropdown,
.acc-hover:hover .acc-dropdown {
  top: 100%;
  opacity: 1;
  visibility: visible;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

.grid-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

.slider-container {
  overflow: hidden;
  width: 100%;
  /* Adjust width as needed */
}

.slider-track,
.slider-wrapper {
  display: flex;
  position: relative;
  transition: transform 0.5s ease-in-out;
}

.slider-slide {
  /* flex: 0 0 auto; */
  width: 100%;
  text-align: center;
  padding: 10px;
}

/* .mySlides {display: none} */
.slideshow-container {
  max-width: 1000px;
  position: relative;
  margin: auto;
}

.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: var(--border-color);
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

/* .active, .dot:hover {
    background-color: #717171;
  } */

/* Fading animation */
.fade {
  animation-name: fade;
  animation-duration: 1.5s;
}

.blog-slider .slick-slide {
  display: grid !important;
}

.slick-slider .slick-list .slick-track {
  display: flex !important;
  flex-wrap: nowrap !important;
}

@keyframes fade {
  from {
    opacity: 0.4;
  }

  to {
    opacity: 1;
  }
}

.swiper-slide {
  width: auto !important;
}

.how-it-works {
  padding: 4px 6px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  color: var(--table-text-color);
  margin-bottom: 2px;
  opacity: 1;
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
  background-color: var(--secondary-bg-color);
  transition: all 0.3s;
}

.how-it-works:hover {
  color: var(--primary-text-color);
}

/* ════════════════════════════════════�table {
  border-color: var(--border-color);
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

/* ── Header row ── */
table thead tr {
  background-color: #F4F4F5;
  color: #71717A;
  font-weight: 600;
  height: 44px;
  font-size: 12px;
  letter-spacing: 0.02em;
  text-transform: capitalize;
}

table thead th {
  border-bottom: 1px solid var(--border-color);
  vertical-align: middle;
}

.dark-mode table thead tr {
  background-color: var(--primary-bg-color);
  color: var(--table-text-color);
}

/* Keep inner header children transparent */
thead tr,
thead td,
thead th,
thead div,
thead span,
thead div button {
  background-color: transparent;
  text-transform: capitalize;
}

/* ── Body rows ── */
table tbody tr {
  height: 54px;
  background-color: transparent;
  cursor: pointer;
  color: var(--primary-text-color);
  font-size: 13px;
  transition: background-color 0.12s ease;
}

table tbody td {
  border-bottom: 1px solid var(--border-color);
  vertical-align: middle;
}

.dark-mode table tbody tr {
  background-color: var(--secondary-bg-color);
  color: var(--primary-text-color);
}

table tbody tr:last-child td {
  border-bottom: none;
}

.module-table table tbody tr {
  height: auto;
}

.variant-table tbody tr {
  height: auto;
  min-height: 53px;
}

/* ── Row hover ── */
table tbody tr:hover {
  background-color: #F4F4F5;
  outline: none;
}

.dark-mode table tbody tr:hover {
  background-color: var(--focus-tab-color);
}

.thead-image {
  min-width: 80px;
  max-width: 80px;
}

.selected-row,
.selected-row:hover,
.dMnwYK:nth-of-type(n) {
  background-color: rgba(var(--primary-bg-color-rgb), 70%) !important;
}

.dark-mode .selected-row,
.dark-mode .selected-row:hover,
.dark-mode .dMnwYK:nth-of-type(n),
.dark-mode .dMnwYK:nth-of-type(n):hover {
  background-color: var(--sidebar-bg-color) !important;
  border-color: var(--border-color) !important;
}

.dMnwYK:hover {
  outline: none !important;
}

.table-image img {
  border: 1px solid var(--border-color);
  padding: 3px;
  border-radius: 4px;
  max-height: 50px;
  display: inline-block;
  margin: 0 auto;
  object-fit: contain;
}

.drag-btn {
  opacity: 0;
}

.table tbody tr:hover .drag-btn {
  opacity: 1 !important;
}

.table-head-checkbox,
.table-body-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  width: 50px;
}

.category-hover img {
  transition: all 0.3s;
}

.category-hover:hover img {
  transform: scale(1.1);
}

.table-body-checkbox {
  height: 55px;
}

/* ── Sticky Table Columns ── */
th.sticky-table-header,
.sticky-table-header {
  position: sticky !important;
  background-color: #F4F4F5 !important;
  z-index: 25 !important;
}

.dark-mode th.sticky-table-header,
.dark-mode .sticky-table-header {
  background-color: var(--primary-bg-color, #1a1a1a) !important;
}

td.sticky-table-cell,
.sticky-table-cell {
  position: sticky !important;
  background-color: #FAFAFA !important;
  z-index: 15 !important;
}

.dark-mode td.sticky-table-cell,
.dark-mode .sticky-table-cell {
  background-color: var(--secondary-bg-color, #242424) !important;
}

table tbody tr:hover td.sticky-table-cell,
table tbody tr:hover .sticky-table-cell {
  background-color: #F4F4F5 !important;
}

.dark-mode table tbody tr:hover td.sticky-table-cell,
.dark-mode table tbody tr:hover .sticky-table-cell {
  background-color: var(--focus-tab-color, #2e2e2e) !important;
}

table tbody tr.selected-row td.sticky-table-cell,
table tbody tr.selected-row:hover td.sticky-table-cell,
table tbody tr.selected-row .sticky-table-cell,
table tbody tr.selected-row:hover .sticky-table-cell {
  background-color: rgba(var(--primary-bg-color-rgb, 244, 246, 248), 70%) !important;
}

.dark-mode table tbody tr.selected-row td.sticky-table-cell,
.dark-mode table tbody tr.selected-row:hover td.sticky-table-cell,
.dark-mode table tbody tr.selected-row .sticky-table-cell,
.dark-mode table tbody tr.selected-row:hover .sticky-table-cell {
  background-color: var(--sidebar-bg-color, #0d0d0d) !important;
}

.sticky-shadow-left {
  box-shadow: 6px 0 10px -2px rgba(0, 0, 0, 0.12) !important;
  border-right: 1px solid var(--border-color) !important;
}

.sticky-shadow-right {
  box-shadow: -6px 0 10px -2px rgba(0, 0, 0, 0.12) !important;
  border-left: 1px solid var(--border-color) !important;
}

.dark-mode .sticky-shadow-left {
  box-shadow: 6px 0 10px -2px rgba(0, 0, 0, 0.4) !important;
}

.dark-mode .sticky-shadow-right {
  box-shadow: -6px 0 10px -2px rgba(0, 0, 0, 0.4) !important;
}

.add-discount-table table thead tr td:last-child,
.add-discount-table table tbody tr td:last-child {
  position: sticky !important;
  right: 0 !important;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  /* width: 200px; */
  /* background-color: inherit; */
  z-index: 5;
}

.css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  max-width: 700px !important;
  margin: 10px !important;
}

.react-datepicker__time-container {
  width: auto !important;
}

.schdule-time .react-datepicker-popper {
  position: relative !important;
  transform: translate(0, 0) !important;
}

.filter-btn {
  background-color: var(--secondary-bg-color);
  border: 1px solid var(--border-color);
  width: 36px;
  height: 36px;
  border-radius: var(--radius-sm);
  transition: all 0.15s ease;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: var(--shadow-card);
}

.filter-btn:hover {
  background-color: var(--focus-tab-color) !important;
  border-color: var(--focus-border-color) !important;
}

.dark-mode .filter-btn:hover {
  background-color: var(--primary-bg-color) !important;
  border-color: var(--focus-border-color) !important;
}

.filter-btn svg {
  width: 16px;
  height: 16px;
  color: var(--table-text-color);
}

.slug-edit {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
}

.gocYik {
  background-color: rgba(var(--primary-bg-color-rgb), 70%) !important;
  color: var(--btn-bg-primary);
  font-weight: 600;
  min-height: 40px !important;
  font-size: 12px;
  border: none !important;
  /* border-bottom: 1px solid var(--border-color) !important; */
}

.dark-mode .gocYik {
  color: var(--table-text-color) !important;
}

.admin-search .MuiPaper-root.MuiPaper-elevation {
  left: 50% !important;
  top: 5% !important;
  transform: translateX(-50%) !important;
}

details {
  padding: 0px !important;
  background-color: var(--secondary-bg-color) !important;
}

details summary {
  padding: 25px !important;
  position: relative;
}

.theme-setting details summary {
  padding: 15px !important;
}

:not(.editor-details)details[open] summary::after {
  content: '';
  top: 100%;
  left: 0;
  position: absolute;
  width: 95%;
  height: 1px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--border-color);
  margin-bottom: 25px;
}

details>div {
  padding: 0px 25px 0px 25px !important;
}

.editor-details details>div {
  padding: 0 !important;
}

.editor-heading {
  font-size: 14px !important;
}

.editor-title {
  font-size: 12px !important;
}

.hover-icon path {
  stroke: #555555;
}

.select-container {
  background-color: #f6f6f6 !important;
  border: none !important;
}

.hover-icon:hover path {
  stroke: #ffffff;
}

.editor-details details>div:last-child {
  padding: 0 !important;
}

.editor-details details>div {
  padding: 0 !important;
}

.editor-heading {
  font-size: 14px !important;
}

.editor-title {
  font-size: 12px !important;
}

.hover-icon path {
  stroke: #555555;
}

.select-container {
  background-color: #f6f6f6 !important;
  border: none !important;
}

.hover-icon:hover path {
  stroke: #ffffff;
}

.editor-details details>div:last-child {
  padding: 0 !important;
}

.theme-setting details summary {
  appearance: none !important;
}

.theme-setting details>div {
  padding: 0px 15px 0px 15px !important;
}

/* details hr {
  display: none !important;
} */

details>div:last-child {
  padding-bottom: 25px !important;
}

.theme-setting details>div:last-child {
  padding-bottom: 15px !important;
}

details>div:first-child {
  padding: 25px 25px 0px 25px !important;
}

details>button:last-child {
  margin-bottom: 25px !important;
  margin-left: 25px !important;
}

.checkbox {
  opacity: 0;
  position: absolute;
}

.checkbox-label {
  background-color: #111;
  width: 50px;
  height: 26px;
  border-radius: 50px;
  position: relative;
  padding: 5px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.checkbox-label .ball {
  background-color: #fff;
  width: 22px;
  height: 22px;
  position: absolute;
  left: 2px;
  top: 2px;
  border-radius: 50%;
  transition: transform 0.2s linear;
}

.checkbox:checked+.checkbox-label .ball {
  transform: translateX(24px);
}

.dark-mode-toggle input[type='checkbox'] {
  position: absolute !important;
}

.dark-mode-toggle .MuiSwitch-thumb {
  background-color: var(--sidebar-bg-color) !important;
}

.dark-mode .dark-mode-toggle .MuiSwitch-track {
  background-color: var(--table-text-color) !important;
}

.subscription-line {
  background: #222;
}

.adminsearch {
  background-color: rgba(var(--primary-bg-color-rgb), 70%);
}

/* .dark-mode .subscription-line {
  background-color: var(--secondary-bg-color);
  border-color: var(--border-color) !important;
} */

.metaFieldgroup>ul {
  padding: 10px;
  background-color: var(--secondary-bg-color);
  border-radius: 4px;
}

.metaFieldgroup>ul>li {
  padding: 7px 15px;
  font-size: 15px;
  text-transform: capitalize;
  width: 100%;
  border-radius: 4px;
  text-align: center;
}

.metaFieldgroup>ul>li:hover {
  background-color: var(--primary-bg-color);
  color: var(--primary-text-color) !important;
  cursor: pointer;
}

.selected-brand {
  border: 2px solid #2c6ecb;
}

.hover-border:hover {
  border: 2px solid #3b82f6;
}

.bg-gray-100 {
  background-color: #f0f0f0;
}

.default-border {
  border: 2px solid transparent;
  transition: border-color 0.3s ease;
}

.selected-border {
  border: 2px solid #3b82f6;
  /* Color for selected section */
}

.page_builder_container {
  border: 2px solid transparent;
  /* Default transparent border */
}

.page_builder_container:hover {
  border: 2px solid transparent;
  /* Transparent border on hover */
}

.page_builder_container.selected {
  border: 2px solid #2c6ecb;
  /* Blue border for selected section */
}

.hover-border {
  border: 2px solid transparent;
  /* Default border is transparent */
  transition: border 0.2s ease-in-out;
}

.hover-border:hover {
  border: 2px solid #3b82f6;
  /* Border color on hover */
}

.product-name-div {
  border: 2px solid transparent;
  transition: border 0.3s ease;
}

.product-name-div:hover {
  border: 2px solid #3b82f6;
}

.active-border {
  border: 2px solid #3b82f6;
}

/* .hover-border {
    transition: border 0.3s ease;
} */

.hover-border:hover {
  border: 2px solid #3b82f6;
}

.parent-hover:hover .child-hover {
  background-color: #6f7a86;
}

.element-title {
  font-size: 12px;
}

.metaFieldgroupCustome>ul {
  padding: 10px;
  background-color: var(--secondary-bg-color);
  border-radius: 4px;
}

.metaFieldgroupCustome>ul>li {
  padding: 7px 15px;
  font-size: 15px;
  text-transform: capitalize;
  width: 100%;
  border-radius: 4px;
  display: flex;
}

.metaFieldgroupCustome>ul>li:hover {
  background-color: var(--primary-bg-color);
  color: var(--primary-text-color) !important;
  cursor: pointer;
}

.bg-radio-button input {
  font-size: 15px !important;
}

.dark-mode .MuiBox-root,
.dark-mode .lucide {
  color: var(--primary-text-color) !important;
  background-color: var(--secondary-bg-color) !important;
  border-color: var(--border-color) !important;
}

.dark-mode .MuiBox-root:hover,
.dark-mode .lucide:hover {
  color: var(--primary-text-color) !important;
  border-color: var(--border-color) !important;
}

.dark-mode .lucide:hover {
  background-color: var(--primary-bg-color) !important;
}

/* Pagination Dark Mode Wrapper Overrides */
.dark-mode div.bg-white:has(> .pagination-container) {
  background-color: var(--secondary-bg-color) !important;
}

/* ============================================================
   GLOBAL FONT APPLICATION
   ============================================================ */
body,
input,
button,
select,
textarea {
  font-family: var(--font-sans) !important;
}

/* ============================================================
   GLOBAL BTN UTILITY CLASS  (backward-compat with old .btn usage)
   ============================================================ */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 9px 16px;
  font-size: 13.5px;
  font-weight: 500;
  font-family: var(--font-sans);
  border-radius: var(--radius-sm);
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  background-color: var(--btn-bg-primary);
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.btn:hover:not(:disabled) {
  background-color: var(--bg-btn-hover);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn:active:not(:disabled) {
  transform: translateY(1px);
  box-shadow: none;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Input Base Utility ── */
.input-base {
  width: 100%;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background-color: var(--secondary-bg-color);
  color: var(--primary-text-color);
  font-size: 13.5px;
  font-family: var(--font-sans);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  outline: none;
}

.input-base::placeholder {
  color: var(--table-text-color);
  opacity: 0.8;
}

.input-base:hover {
  border-color: var(--focus-border-color);
}

.input-base:focus {
  border-color: var(--focus-border-color) !important;
  box-shadow: 0 0 0 3px rgba(var(--focus-border-color-rgb), 0.12);
}

.input-base--error {
  border-color: var(--color-danger) !important;
  box-shadow: 0 0 0 3px rgba(215, 44, 13, 0.1) !important;
}

.input-help-text {
  font-size: 12px;
  color: var(--table-text-color);
  margin-top: 4px;
}

.input-error-text {
  font-size: 12px;
  color: var(--color-danger);
  margin-top: 4px;
  font-weight: 500;
}

/* ── Status Badge System ── */
.badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  font-family: var(--font-sans);
  white-space: nowrap;
}

.badge-success {
  background-color: var(--color-success-bg);
  color: var(--color-success);
}

.badge-warning {
  background-color: var(--color-warning-bg);
  color: var(--color-warning);
}

.badge-danger {
  background-color: var(--color-danger-bg);
  color: var(--color-danger);
}

.badge-info {
  background-color: var(--color-info-bg);
  color: var(--color-info);
}

.badge-neutral {
  background-color: var(--focus-tab-color);
  color: var(--table-text-color);
}

/* ============================================================
   PAGINATION COMPONENT
   ============================================================ */
.pagination-container {
  background-color: var(--secondary-bg-color);
  border-top: 1px solid var(--border-color);
  border-radius: 0 0 var(--radius-md) var(--radius-md);
}

.dark-mode .pagination-container {
  background-color: var(--secondary-bg-color);
  border-top-color: var(--border-color);
}

.dark-mode div.bg-white:has(> .pagination-container) {
  background-color: var(--secondary-bg-color) !important;
}

/* ============================================================
   SELECT COMPONENT SYSTEM
   All colors use CSS variables — dark/light mode is automatic.
   Never write manual select CSS in any page/component file.
   ============================================================ */

/* ── Label ── */
.select-label {
  color: var(--primary-text-color);
}

/* ── Trigger Button (the visible "select box") ── */
.select-trigger {
  background-color: var(--secondary-bg-color);
  border-color: var(--border-color);
  color: var(--primary-text-color);
  font-family: var(--font-sans);
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

/* Hover state — subtle background shift */
.select-trigger:not(.select-trigger--disabled):hover {
  background-color: var(--focus-tab-color);
  border-color: var(--focus-border-color);
}

/* Open / active state — focused ring + accent border */
.select-trigger--open {
  border-color: var(--focus-border-color) !important;
  box-shadow: 0 0 0 3px rgba(var(--focus-border-color-rgb), 0.12);
  background-color: var(--secondary-bg-color) !important;
}

/* Error state */
.select-trigger--error {
  border-color: var(--color-danger) !important;
  box-shadow: 0 0 0 3px rgba(215, 44, 13, 0.1) !important;
}

/* Placeholder text color */
.select-trigger--empty .select-trigger-placeholder,
.select-trigger--empty>div>span {
  color: var(--table-text-color);
  opacity: 0.85;
}

/* Disabled / loading */
.select-trigger--disabled {
  background-color: var(--focus-tab-color) !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}

/* Caret / arrow icon */
.select-arrow-icon {
  color: var(--table-text-color);
  flex-shrink: 0;
  opacity: 0.7;
}

/* Spinner icon */
.select-icon {
  color: var(--table-text-color);
}

/* Clear (×) button inside trigger */
.select-clear-btn {
  color: var(--table-text-color);
  opacity: 0.7;
  border-radius: 50%;
  transition: all 0.15s ease;
}

.select-clear-btn:hover {
  background-color: var(--focus-tab-color);
  color: var(--primary-text-color);
  opacity: 1;
}

/* ── Tag chips for multi-select — Shopify pill style ── */
.select-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px 2px 10px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 20px;
  -webkit-user-select: none;
          user-select: none;
  background-color: var(--focus-tab-color);
  color: var(--primary-text-color);
  border: 1px solid var(--border-color);
  font-family: var(--font-sans);
  transition: all 0.1s ease;
}

.select-chip:hover {
  background-color: var(--primary-bg-color);
}

.select-chip-remove {
  color: var(--table-text-color);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s;
  border-radius: 50%;
  padding: 1px;
}

.select-chip-remove:hover {
  color: var(--color-danger);
  background-color: rgba(215, 44, 13, 0.08);
}

/* ── Popover Paper ── */
.select-popover-paper {
  background-color: var(--secondary-bg-color) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: var(--radius-md) !important;
  box-shadow: var(--shadow-popover) !important;
  overflow: hidden;
}

.dark-mode .select-popover-paper {
  box-shadow:
    0 20px 30px -8px rgba(0, 0, 0, 0.5),
    0 6px 10px -3px rgba(0, 0, 0, 0.35) !important;
}

/* ── Search input inside popover ── */
.select-search-wrap {
  border-color: var(--border-color);
}

.select-search-input {
  background-color: var(--primary-bg-color);
  border-color: var(--border-color);
  color: var(--primary-text-color);
}

.select-search-input::placeholder {
  color: var(--table-text-color);
}

.select-search-input:focus {
  border-color: var(--focus-border-color) !important;
  box-shadow: none;
}

.select-search-clear {
  color: var(--table-text-color);
}

.select-search-clear:hover {
  color: var(--primary-text-color);
}

/* ── "Clear Selection" row ── */
.select-option-clear {
  color: var(--table-text-color);
}

.select-option-clear:hover {
  background-color: var(--primary-bg-color);
  color: var(--primary-text-color);
}

/* ── Option rows ── */
.select-option {
  color: var(--primary-text-color);
  font-family: var(--font-sans);
  transition: background-color 0.1s ease;
  border-radius: 0;
}

/* Default (un-selected, un-highlighted) hover */
.select-option--default:hover {
  background-color: var(--focus-tab-color);
}

/* Keyboard highlighted (ArrowUp / ArrowDown) */
.select-option--highlighted {
  background-color: var(--focus-tab-color);
  color: var(--primary-text-color);
}

/* Selected option — Shopify uses a subtle background, not full dark */
.select-option--selected {
  background-color: var(--focus-tab-color);
  color: var(--primary-text-color);
  font-weight: 600;
}

.select-option--selected:hover {
  background-color: var(--primary-bg-color);
}

/* Check icon shown next to selected option */
.select-check-icon {
  color: var(--btn-bg-primary);
}

.dark-mode .select-check-icon {
  color: var(--primary-text-color);
}

/* ── Multi-select checkbox ── */
.select-checkbox {
  border-color: var(--border-color);
  background-color: var(--secondary-bg-color);
  color: transparent;
  border-radius: 4px;
  transition: all 0.12s ease;
}

.select-checkbox--unchecked {
  border-color: #E4E4E7 !important;
}

.select-checkbox--unchecked:hover {
  border-color: var(--focus-border-color);
}

.select-checkbox--checked {
  background-color: var(--btn-bg-primary);
  border-color: var(--btn-bg-primary);
  color: #ffffff;
}

/* ── Empty state ── */
.select-empty {
  color: var(--table-text-color);
}

/* ============================================================
   SEARCH COMPONENT SYSTEM
   ============================================================ */
.search-component-input {
  background-color: var(--secondary-bg-color) !important;
  border: 1px solid var(--border-color) !important;
  color: var(--primary-text-color) !important;
  font-family: var(--font-sans);
  font-size: 13.5px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.search-component-input::placeholder {
  color: var(--table-text-color) !important;
  opacity: 0.8;
}

.search-component-input:hover {
  border-color: var(--focus-border-color) !important;
}

.search-component-input:focus {
  border-color: var(--focus-border-color) !important;
  box-shadow: 0 0 0 2.5px rgba(var(--focus-border-color-rgb), 0.15) !important;
  background-color: var(--secondary-bg-color) !important;
}

.search-component-clear-btn {
  color: var(--table-text-color);
  opacity: 0.7;
  border-radius: 50%;
  padding: 2px;
  transition: all 0.15s ease;
}

.search-component-clear-btn:hover {
  background-color: var(--focus-tab-color);
  color: var(--primary-text-color);
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/ShopeasyUiKit.css"],"names":[],"mappings":"AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;EAClC,yBAAyB;EACzB,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;;EAE3B,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;EACrC,6BAA6B;EAC7B,uCAAuC;;EAEvC,eAAe;EACf,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,qCAAqC;;EAErC,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;;EAEpC,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;;EAEpC,kBAAkB;EAClB,kFAAkF;EAClF,0FAA0F;;EAE1F,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;;EAEjB,eAAe;EACf,yFAAyF;;EAEzF,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,wBAAwB;;EAExB,uDAAuD;EACvD,oEAAoE;AACtE;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;EAC3B,kCAAkC;EAClC,6BAA6B;EAC7B,oCAAoC;EACpC,6BAA6B;EAC7B,uCAAuC;EACvC,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,qCAAqC;EACrC,6BAA6B;EAC7B,uCAAuC;EACvC,0BAA0B;EAC1B,iCAAiC;EACjC,gFAAgF;EAChF,yFAAyF;AAC3F;;AAEA;;;;;;;;;;;;EAYE,2EAA2E;EAC3E,6DAA6D;EAC7D,iDAAiD;EACjD,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wDAAwD;EACxD,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;;GAEG;;AAEH;EACE,sDAAsD;EACtD,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;;;EAIE,oDAAoD;AACtD;;AAEA;;;;;;;;;;;GAWG;AACH;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;GAgBG;;AAEH;;;;;;EAME,4BAA4B;AAC9B;;AAEA;;;;;;EAME,0BAA0B;AAC5B;;AAEA,8DAA8D;AAC9D;;EAEE,yCAAyC;EACzC,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;;GAGG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;;;;;;EAOE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,oEAAoE;EACpE,mEAAmE;EACnE,+BAA+B;AACjC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,mEAAmE;EACnE,+DAA+D;AACjE;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;;;;EAKE,0CAA0C;EAC1C,yCAAyC;EACzC,4DAA4D;AAC9D;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;;;;;;EAME,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;;;;;;;;;GASG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,gDAAgD;EAChD,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;;;EAGE,4DAA4D;EAC5D,yCAAyC;AAC3C;;AAEA;;EAEE,sDAAsD;EACtD,2CAA2C;AAC7C;;AAEA;EACE;IACE,0DAA0D;IAC1D,yCAAyC;EAC3C;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;;EAEE,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;EAC9B,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8CAA8C;EAC9C,oDAAoD;EACpD,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;EACV,2CAA2C;EAC3C,oDAAoD;AACtD;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;;KAEK;;AAEL,qBAAqB;AACrB;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;;;qBAOqB;AACrB;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA,2CAA2C;AAC3C;;;;;;EAME,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,mEAAmE;AACrE;;AAEA;;;;EAIE,oDAAoD;EACpD,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA,+BAA+B;AAC/B;;EAEE,2BAA2B;EAC3B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,6DAA6D;AAC/D;;AAEA;;EAEE,2BAA2B;EAC3B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,+DAA+D;AACjE;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,4DAA4D;AAC9D;;AAEA;;;;EAIE,kFAAkF;AACpF;;AAEA;;;;EAIE,6DAA6D;AAC/D;;AAEA;EACE,0DAA0D;EAC1D,sDAAsD;AACxD;;AAEA;EACE,2DAA2D;EAC3D,qDAAqD;AACvD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;;EAEE,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,mDAAmD;EACnD,kDAAkD;AACpD;;AAEA;EACE,oDAAoD;EACpD,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,mEAAmE;EACnE,4BAA4B;EAC5B,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;GAEG;;AAEH;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,2CAA2C;EAC3C,sDAAsD;EACtD,4CAA4C;AAC9C;;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;AACtD;;AAEA,2CAA2C;AAC3C;EACE,sDAAsD;AACxD;;AAEA;;iEAEiE;AACjE;;;;;EAKE,wCAAwC;AAC1C;;AAEA;;iEAEiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,0BAA0B;EAC1B,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,qCAAqC;EACrC,+BAA+B;EAC/B,2CAA2C;EAC3C,gCAAgC;EAChC,iBAAiB;EACjB,6BAA6B;EAC7B,0DAA0D;EAC1D,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;EAClD,+DAA+D;AACjE;;AAEA;EACE,4CAA4C;EAC5C,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;;iEAEiE;AACjE;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;;;;iEAIiE;;AAEjE,gBAAgB;AAChB;EACE,gCAAgC;AAClC;;AAEA,oDAAoD;AACpD;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,uFAAuF;AACzF;;AAEA,0CAA0C;AAC1C;EACE,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA,uDAAuD;AACvD;EACE,kDAAkD;EAClD,+DAA+D;EAC/D,sDAAsD;AACxD;;AAEA,gBAAgB;AAChB;EACE,4CAA4C;EAC5C,uDAAuD;AACzD;;AAEA,2BAA2B;AAC3B;;EAEE,8BAA8B;EAC9B,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,mDAAmD;EACnD,8BAA8B;EAC9B,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;EAC9B,cAAc;EACd,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;AAChC;;AAEA,oCAAoC;AACpC;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,UAAU;AACZ;;AAEA,0DAA0D;AAC1D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;EAChC,qCAAqC;EACrC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,sDAAsD;EACtD,gDAAgD;EAChD,0CAA0C;EAC1C,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE;;kDAEgD;AAClD;;AAEA,sCAAsC;AACtC;EACE,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,wCAAwC;AAC1C;;AAEA,+CAA+C;AAC/C;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,sEAAsE;AACtE;EACE,wCAAwC;EACxC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,6CAA6C;AAC7C;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,gCAAgC;AAChC;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,8BAA8B;AAChC;;AAEA;;iEAEiE;AACjE;EACE,sDAAsD;EACtD,gDAAgD;EAChD,2CAA2C;EAC3C,6BAA6B;EAC7B,iBAAiB;EACjB,uFAAuF;AACzF;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;EAClD,4EAA4E;EAC5E,sDAAsD;AACxD;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,UAAU;AACZ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900&display=swap');\n\n.menu-text {\n  transition: all 3s !important;\n  font-size: 14px !important;\n}\n\n:root {\n  /* ── Core Brand ── */\n  --sidebar-bg-color: #FAFAFA;\n  --sidebar-bg-color-rgb: 26, 26, 26;\n  --btn-bg-primary: #1a1a1a;\n  --btn-bg-primary-rgb: 26, 26, 26;\n  --bg-btn-hover: #000000;\n  --bg-btn-hover-rgb: 0, 0, 0;\n\n  /* ── Surface Colors ── */\n  --primary-bg-color: #FAFAFA;\n  --primary-bg-color-rgb: 244, 246, 248;\n  --secondary-bg-color: #ffffff;\n  --secondary-bg-color-rgb: 255, 255, 255;\n\n  /* ── Text ── */\n  --primary-text-color: #1a1a1a;\n  --primary-text-color-rgb: 26, 26, 26;\n  --table-text-color: #6d7175;\n  --table-text-color-rgb: 109, 113, 117;\n\n  /* ── Borders ── */\n  --border-color: #e1e3e5;\n  --border-color-rgb: 225, 227, 229;\n  --focus-border-color: #5c5f62;\n  --focus-border-color-rgb: 92, 95, 98;\n\n  /* ── Focus / Tabs ── */\n  --focus-tab-color: #f1f2f3;\n  --focus-tab-color-rgb: 241, 242, 243;\n\n  /* ── Shadows ── */\n  --shadow-card: 0 1px 3px 0 rgba(0, 0, 0, 0.06), 0 1px 2px -1px rgba(0, 0, 0, 0.04);\n  --shadow-popover: 0 10px 20px -4px rgba(0, 0, 0, 0.10), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n\n  /* ── Radius ── */\n  --radius-sm: 6px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n\n  /* ── Font ── */\n  --font-sans: 'Inter', 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n\n  /* ── Status Colors ── */\n  --color-success: #008060;\n  --color-success-bg: #e3f1ec;\n  --color-warning: #b98900;\n  --color-warning-bg: #fdf3d7;\n  --color-danger: #d72c0d;\n  --color-danger-bg: #fce8e6;\n  --color-info: #0070c4;\n  --color-info-bg: #e8f4fd;\n\n  --tawk-header-background-color: var(--sidebar-bg-color);\n  --tawk-header-background-color-rgb: var(var(--sidebar-bg-color-rgb));\n}\n\n.dark-mode {\n  --sidebar-bg-color: #0d0d0d;\n  --sidebar-bg-color-rgb: 13, 13, 13;\n  --primary-bg-color: #1a1a1a;\n  --primary-bg-color-rgb: 26, 26, 26;\n  --secondary-bg-color: #242424;\n  --secondary-bg-color-rgb: 36, 36, 36;\n  --primary-text-color: #e3e3e3;\n  --primary-text-color-rgb: 227, 227, 227;\n  --border-color: #3a3a3a;\n  --border-color-rgb: 58, 58, 58;\n  --table-text-color: #9ca3af;\n  --table-text-color-rgb: 156, 163, 175;\n  --focus-border-color: #6b7280;\n  --focus-border-color-rgb: 107, 114, 128;\n  --focus-tab-color: #2e2e2e;\n  --focus-tab-color-rgb: 46, 46, 46;\n  --shadow-card: 0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 1px 2px -1px rgba(0, 0, 0, 0.2);\n  --shadow-popover: 0 10px 20px -4px rgba(0, 0, 0, 0.45), 0 4px 6px -2px rgba(0, 0, 0, 0.3);\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\ntextarea:-webkit-autofill:active,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus,\nselect:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 1000px var(--secondary-bg-color) inset !important;\n  -webkit-text-fill-color: var(--primary-text-color) !important;\n  caret-color: var(--primary-text-color) !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n.close.sidebar .menu-text {\n  display: none;\n  transition: all 3s !important;\n}\n\n.close-btn {\n  width: 25px;\n  height: 25px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(var(--primary-bg-color-rgb), 70%);\n  color: var(--table-text-color);\n  transition: all 0.3s;\n  border-radius: 4px;\n  border: none;\n  outline: none;\n}\n\n.close-btn:hover {\n  background-color: var(--primary-bg-color);\n  color: var(--primary-text-color);\n}\n\n/* .min-w-\\[240px\\] .sidebar .menu-text {\n    display: block;\n} */\n\n.react-datepicker__input-container input {\n  background-color: var(--secondary-bg-color) !important;\n  color: var(--primary-text-color);\n  border-color: var(--border-color) !important;\n}\n\n.menu-item,\n.menu-item-close {\n  position: relative;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  width: 100%;\n  z-index: 1;\n  font-weight: 500 !important;\n  overflow: hidden;\n  transition: all 0.3s;\n  font-size: 14px !important;\n  padding: 9px !important;\n  background-color: transparent;\n}\n\n.menu-arrow:hover {\n  background-color: rgba(250, 249, 246, 10%);\n  /* opacity: 10%; */\n}\n\n.tawk-button {\n  background-color: var(--sidebar-bg-color) !important;\n}\n\n.status-bedge {\n  padding: 4px 12px !important;\n  border: 1px solid;\n  position: relative;\n  display: inline-block;\n  border-radius: 30px;\n  font-weight: 500;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n\n.menu-item-close {\n  color: #c9c8c8 !important;\n}\n\n.dark-mode .menu-item-close {\n  color: var(--table-text-color) !important;\n}\n\n.menu-item-close:hover {\n  color: white !important;\n}\n\n.out-of-stock {\n  background-color: #fee2e2;\n  color: #ef4444;\n}\n\n.dark-mode .out-of-stock {\n  color: #fee2e2;\n  background-color: rgb(211, 66, 66);\n}\n\n.in-stock {\n  background-color: #dcfce7;\n  color: #16a34a;\n}\n\n.dark-mode .in-stock {\n  background-color: #16a34a;\n  color: #dcfce7;\n}\n\n.yellow {\n  background-color: #fef9c3;\n  color: #ca8a04;\n}\n\n.dark-mode .yellow {\n  color: #222222;\n  background-color: #ecb745;\n}\n\n.menu-item span,\n.menu-item-close span {\n  font-size: 14px;\n  font-weight: 500 !important;\n  /* letter-spacing: 0.5s !important; */\n}\n\n.menu-item::after,\n.menu-item-close::after {\n  content: '';\n  width: 100% !important;\n  height: 100% !important;\n  background-color: #faf9f6;\n  opacity: 10% !important;\n  opacity: 1;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: -1;\n  transition: all 0.3s;\n  border-radius: 6px 5px 5px 6px !important;\n}\n\n.fixed-sidebar .menu-item::after,\n.fixed-sidebar .menu-item-close::after {\n  background-color: #faf9f6;\n  opacity: 10%;\n}\n\n.dark-mode .menu-item::after,\n.dark-mode .menu-item-close::after,\n.dark-mode .fixed-sidebar .menu-item::after,\n.dark-mode .fixed-sidebar .menu-item-close::after {\n  background-color: var(--primary-bg-color) !important;\n}\n\n/* .menu-item::before,\n.menu-item-close::before {\n    content: '';\n    width: 2px;\n    height: 100%;\n    background-color: white;\n    border-radius: 10px;\n    position: absolute;\n    left: 0;\n    top: 0;\n    transition: all 0.3s;\n} */\n.fixed-sidebar .menu-item-close::after,\n.fixed-sidebar .menu-item-close::before {\n  color: #faf9f6;\n}\n\n.dark-mode .fixed-sidebar .menu-item-close::after,\n.dark-mode .fixed-sidebar .menu-item-close::before,\n.dark-mode .menu-item-close::after,\n.dark-mode .menu-item-close::before {\n  color: var(--table-text-color) !important;\n}\n\n.menu-item-close::after {\n  opacity: 0;\n  color: #faf9f6 !important;\n  background-color: transparent !important;\n}\n\n.menu-item-close::before {\n  top: 100%;\n  color: #faf9f6 !important;\n}\n\n/* select {\n  appearance: none;\n  padding: 8px 30px 8px 12px !important;\n  font-size: 14px !important;\n  border-radius: 4px !important;\n  border: 1px solid var(--border-color);\n  border-color: var(--border-color) !important;\n  cursor: pointer !important;\n  outline: none !important;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  background-color: var(--secondary-bg-color) !important;\n} */\n\n.live-editor select {\n  appearance: none;\n}\n\n.filterType select {\n  cursor: auto;\n}\n\n.filter {\n  min-width: 300px !important;\n}\n\nselect:focus {\n  border: 1px solid #6b7280 !important;\n}\n\n.adminseacrh select {\n  border: none;\n  padding: 8px 10px;\n}\n\n.adminseacrh select:focus {\n  border: none;\n}\n\n/* input[type='text'],\ninput[type='number'],\ninput[type='Number'],\ninput[type='email'],\ninput[type='password'],\ninput[type='tel'],\ntextarea {\n  padding: 8px 12px !important;\n  font-size: 14px !important;\n  line-height: 20px !important;\n  border-radius: 4px !important;\n  font-weight: 400 !important;\n  box-shadow: none !important;\n  outline: none !important;\n  /* background: transparent !important \n  /* background-color: var(--secondary-bg-color) ; \n} */\n\n.pos-input input[type='text'],\n.pos-input input[type='number'],\n.pos-input input[type='Number'],\n.pos-input input[type='email'],\n.pos-input input[type='password'],\n.pos-input textarea {\n  padding: 6px 12px !important;\n}\n\n.editor-title input[type='text'],\n.editor-title input[type='number'],\n.editor-title input[type='Number'],\n.editor-title input[type='email'],\n.editor-title input[type='password'],\n.editor-title textarea {\n  font-size: 12px !important;\n}\n\n/* ── Global Input & Textarea Placeholder Standardization ── */\ninput::placeholder,\ntextarea::placeholder {\n  color: var(--table-text-color) !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  opacity: 1 !important;\n}\n\n.bg input {\n  /* padding: 12px 12px !important; */\n  font-size: 15px !important;\n}\n\n.bg button:not(.MuiButtonBase-root) {\n  padding: 10px 20px !important;\n}\n\n.bg .autocomplete .MuiFormControl-root .MuiInputBase-root {\n  padding: 13px 35px 13px 12px !important;\n}\n\n.MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track {\n  background-color: var(--btn-bg-primary) !important;\n}\n\n/* input[type=checkbox] {\n    position: relative;\n    cursor: pointer;\n} */\n\n.MuiButtonBase-root.MuiCheckbox-root input[type='checkbox'] {\n  position: absolute;\n}\n\n.MuiButtonBase-root.MuiCheckbox-root .MuiSvgIcon-root {\n  width: 19px !important;\n  height: 19px !important;\n  font-weight: 400;\n}\n\n.MuiButtonBase-root.MuiCheckbox-root:hover {\n  background-color: transparent !important;\n}\n\n.dark-mode input[type='text'],\n.dark-mode input[type='file'],\n.dark-mode input[type='number'],\n.dark-mode input[type='Number'],\n.dark-mode input[type='email'],\n.dark-mode input[type='password'],\n.dark-mode textarea {\n  background-color: transparent !important;\n  color: var(--table-text-color);\n}\n\n.file-tag-hover {\n  border: 2px dashed rgba(var(--sidebar-bg-color-rgb), 30%) !important;\n  background-color: rgba(var(--primary-bg-color-rgb), 70%) !important;\n  transition: all 0.3s !important;\n}\n\n.dark-mode .file-tag-hover {\n  border: 2px dashed var(--border-color) !important;\n}\n\n.file-tag-hover:hover {\n  background-color: rgba(var(--primary-bg-color-rgb), 90%) !important;\n  border-color: rgba(var(--sidebar-bg-color-rgb), 60%) !important;\n}\n\n.dark-mode .file-tag-hover:hover {\n  background-color: var(--primary-bg-color);\n}\n\n.dark-mode select {\n  background-color: var(--secondary-bg-color);\n  color: var(--table-text-color);\n}\n\n.ql-container.ql-snow,\n.ql-toolbar.ql-snow {\n  border-color: var(--border-color) !important;\n}\n\n.ql-snow .ql-stroke,\n.ql-snow .ql-picker,\n.ql-snow .ql-fill,\n.ql-editor.ql-blank::before,\n.ql-editor {\n  stroke: var(--table-text-color) !important;\n  color: var(--table-text-color) !important;\n  /* background-color: var(--secondary-bg-color) !important; */\n}\n\n.MuiRating-icon.MuiRating-iconEmpty {\n  color: var(--table-text-color) !important;\n}\n\n.apexcharts-text.apexcharts-xaxis-label,\n.apexcharts-text.apexcharts-yaxis-label {\n  fill: var(--table-text-color) !important;\n}\n\ninput[type='text']:focus,\ninput[type='number']:focus,\ninput[type='Number']:focus,\ninput[type='email']:focus,\ninput[type='password']:focus,\ntextarea:focus {\n  border-color: #454545 !important;\n}\n\ninput[type='date'] {\n  padding: 8px 12px !important;\n  font-size: 14px !important;\n  line-height: 20px !important;\n  border-radius: 4px !important;\n  font-weight: 400 !important;\n  cursor: pointer !important;\n}\n\n/* .select-arrow {\n  position: absolute;\n  top: 50%;\n  right: 14px;\n  z-index: 5 !important;\n  transform: translateY(-50%);\n  border-top: 5px solid var(--table-text-color);\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n} */\n\nsummary {\n  cursor: pointer !important;\n}\n\n.data-form {\n  border-radius: 4px;\n  background-color: var(--secondary-bg-color) !important;\n  border: 1px solid var(--border-color) !important;\n  padding: 30px;\n  margin: 0 auto;\n}\n\nform label {\n  display: block;\n  color: var(--table-text-color);\n  font-weight: 500;\n  font-size: 13px;\n  margin-bottom: 4px;\n  text-transform: capitalize !important;\n}\n\n.MuiRating-root label {\n  font-size: 25px !important;\n  color: inherit !important;\n}\n\n.rdt_TableHeader {\n  border-bottom: 1px solid var(--border-color) !important;\n}\n\n.autocomplete .MuiFormControl-root .MuiInputBase-root {\n  padding: 6px 35px 6px 12px !important;\n  /* background-color: var(--secondary-bg-color); */\n}\n\n.MuiPaper-root.MuiPaper-elevation,\n.MuiAutocomplete-noOptions,\n.MuiPaper-root.MuiPaper-elevation>div {\n  /* background-color: var(--secondary-bg-color) !important; */\n  color: var(--table-text-color) !important;\n}\n\n.dark-mode .MuiPaper-root,\n.dark-mode .MuiPopover-paper {\n  background-color: var(--secondary-bg-color) !important;\n  color: var(--primary-text-color) !important;\n}\n\n@media (max-width: 767px) {\n  .MuiPaper-root.MuiPaper-elevation>div {\n    /* background-color: var(--sidebar-bg-color) !important; */\n    color: var(--table-text-color) !important;\n  }\n}\n\n.live-editor-responsive .MuiPaper-root.MuiPaper-elevation {\n  max-height: 90% !important;\n}\n\n.MuiSvgIcon-root {\n  fill: var(--table-text-color) !important;\n}\n\n.dark-mode .autocomplete .MuiFormControl-root .MuiInputBase-root {\n  background-color: transparent !important;\n  color: var(--table-text-color);\n}\n\n.autocomplete .MuiFormControl-root .MuiInputBase-root .MuiOutlinedInput-notchedOutline,\n.productLaunch .MuiFormControl-root .MuiInputBase-root .MuiOutlinedInput-notchedOutline {\n  border-color: var(--border-color) !important;\n  border-radius: 4px;\n}\n\n.autocomplete .MuiFormControl-root .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  /* border-color: black !important; */\n  border: 1px solid #454545 !important;\n  outline: none !important;\n}\n\n.autocomplete .MuiFormControl-root .MuiInputBase-root .MuiInputBase-input {\n  padding: 0 !important;\n  line-height: 20px !important;\n  font-size: 14px !important;\n  color: var(--table-text-color);\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  border-radius: 8px !important;\n}\n\n.autocomplete .MuiFormControl-root .MuiAutocomplete-selected-value {\n  text-overflow: ellipsis !important;\n}\n\n.autocomplete .MuiFormControl-root .MuiInputBase-root input::placeholder {\n  color: var(--table-text-color) !important;\n}\n\n.productLaunch .MuiStack-root {\n  padding: 0;\n  overflow: hidden;\n}\n\n.contryCode .MuiFormControl-root .MuiInputBase-root .MuiOutlinedInput-notchedOutline {\n  border-radius: 4px 0 0 4px !important;\n  border-right: none;\n}\n\n.contryCode input {\n  border-radius: 0px 4px 4px 0 !important;\n  /* border-left: none; */\n}\n\n.phone-input-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border: 1px solid var(--border-color, #e5e5e5);\n  background-color: var(--secondary-bg-color, #ffffff);\n  border-radius: 8px;\n  height: 36px;\n  overflow: hidden;\n  transition: border-color 150ms ease;\n}\n\n.phone-input-container:focus-within {\n  border-color: var(--focus-border-color, #a3a3a6);\n}\n\n.phone-input-container .react-select__control {\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  height: 34px !important;\n  min-height: 34px !important;\n  border-radius: 0 !important;\n}\n\n.phone-input-container .react-select__control:hover {\n  border: none !important;\n}\n\n.back-arrow {\n  width: 45px;\n  height: 45px;\n  background-color: transparent;\n  font-size: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  border-radius: 100%;\n}\n\n.back-arrow:hover {\n  background-color: var(--secondary-bg-color);\n}\n\n.headerMenu .headerMenuBtn {\n  opacity: 0;\n  transition: all 0.3s;\n}\n\n.headerMenu {\n  transition: all 0.3s;\n}\n\n.headerMenu:hover .headerMenuBtn,\n.headerMenu:hover {\n  opacity: 1;\n  color: var(--primary-text-color) !important;\n  background-color: var(--primary-bg-color) !important;\n}\n\n.menu-hover,\n.acc-hover {\n  position: relative;\n}\n\n.menu-hover .menu-dropdown,\n.acc-hover .acc-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  opacity: 0;\n  height: auto;\n  visibility: hidden;\n  z-index: 20;\n  transition: all 0.2s;\n}\n\n.menu-hover .menu-dropdown {\n  left: 0 !important;\n}\n\n.header:hover .acc-dropdown {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.menu-hover:hover .menu-dropdown,\n.acc-hover:hover .acc-dropdown {\n  top: 100%;\n  opacity: 1;\n  visibility: visible;\n}\n\n.grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n.grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.grid-cols-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.grid-cols-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.grid-cols-5 {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.grid-cols-6 {\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n}\n\n.grid-cols-7 {\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n}\n\n.grid-cols-8 {\n  grid-template-columns: repeat(8, minmax(0, 1fr));\n}\n\n.grid-cols-9 {\n  grid-template-columns: repeat(9, minmax(0, 1fr));\n}\n\n.slider-container {\n  overflow: hidden;\n  width: 100%;\n  /* Adjust width as needed */\n}\n\n.slider-track,\n.slider-wrapper {\n  display: flex;\n  position: relative;\n  transition: transform 0.5s ease-in-out;\n}\n\n.slider-slide {\n  /* flex: 0 0 auto; */\n  width: 100%;\n  text-align: center;\n  padding: 10px;\n}\n\n/* .mySlides {display: none} */\n.slideshow-container {\n  max-width: 1000px;\n  position: relative;\n  margin: auto;\n}\n\n.dot {\n  cursor: pointer;\n  height: 15px;\n  width: 15px;\n  margin: 0 2px;\n  background-color: var(--border-color);\n  border-radius: 50%;\n  display: inline-block;\n  transition: background-color 0.6s ease;\n}\n\n/* .active, .dot:hover {\n    background-color: #717171;\n  } */\n\n/* Fading animation */\n.fade {\n  animation-name: fade;\n  animation-duration: 1.5s;\n}\n\n.blog-slider .slick-slide {\n  display: grid !important;\n}\n\n.slick-slider .slick-list .slick-track {\n  display: flex !important;\n  flex-wrap: nowrap !important;\n}\n\n@keyframes fade {\n  from {\n    opacity: 0.4;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.swiper-slide {\n  width: auto !important;\n}\n\n.how-it-works {\n  padding: 4px 6px;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  white-space: nowrap;\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: 400;\n  color: var(--table-text-color);\n  margin-bottom: 2px;\n  opacity: 1;\n  display: inline-flex;\n  align-items: center;\n  margin-left: 10px;\n  background-color: var(--secondary-bg-color);\n  transition: all 0.3s;\n}\n\n.how-it-works:hover {\n  color: var(--primary-text-color);\n}\n\n/* ════════════════════════════════════�table {\n  border-color: var(--border-color);\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n/* ── Header row ── */\ntable thead tr {\n  background-color: #F4F4F5;\n  color: #71717A;\n  font-weight: 600;\n  height: 44px;\n  font-size: 12px;\n  letter-spacing: 0.02em;\n  text-transform: capitalize;\n}\n\ntable thead th {\n  border-bottom: 1px solid var(--border-color);\n  vertical-align: middle;\n}\n\n.dark-mode table thead tr {\n  background-color: var(--primary-bg-color);\n  color: var(--table-text-color);\n}\n\n/* Keep inner header children transparent */\nthead tr,\nthead td,\nthead th,\nthead div,\nthead span,\nthead div button {\n  background-color: transparent;\n  text-transform: capitalize;\n}\n\n/* ── Body rows ── */\ntable tbody tr {\n  height: 54px;\n  background-color: transparent;\n  cursor: pointer;\n  color: var(--primary-text-color);\n  font-size: 13px;\n  transition: background-color 0.12s ease;\n}\n\ntable tbody td {\n  border-bottom: 1px solid var(--border-color);\n  vertical-align: middle;\n}\n\n.dark-mode table tbody tr {\n  background-color: var(--secondary-bg-color);\n  color: var(--primary-text-color);\n}\n\ntable tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.module-table table tbody tr {\n  height: auto;\n}\n\n.variant-table tbody tr {\n  height: auto;\n  min-height: 53px;\n}\n\n/* ── Row hover ── */\ntable tbody tr:hover {\n  background-color: #F4F4F5;\n  outline: none;\n}\n\n.dark-mode table tbody tr:hover {\n  background-color: var(--focus-tab-color);\n}\n\n.thead-image {\n  min-width: 80px;\n  max-width: 80px;\n}\n\n.selected-row,\n.selected-row:hover,\n.dMnwYK:nth-of-type(n) {\n  background-color: rgba(var(--primary-bg-color-rgb), 70%) !important;\n}\n\n.dark-mode .selected-row,\n.dark-mode .selected-row:hover,\n.dark-mode .dMnwYK:nth-of-type(n),\n.dark-mode .dMnwYK:nth-of-type(n):hover {\n  background-color: var(--sidebar-bg-color) !important;\n  border-color: var(--border-color) !important;\n}\n\n.dMnwYK:hover {\n  outline: none !important;\n}\n\n.table-image img {\n  border: 1px solid var(--border-color);\n  padding: 3px;\n  border-radius: 4px;\n  max-height: 50px;\n  display: inline-block;\n  margin: 0 auto;\n  object-fit: contain;\n}\n\n.drag-btn {\n  opacity: 0;\n}\n\n.table tbody tr:hover .drag-btn {\n  opacity: 1 !important;\n}\n\n.table-head-checkbox,\n.table-body-checkbox {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 45px;\n  width: 50px;\n}\n\n.category-hover img {\n  transition: all 0.3s;\n}\n\n.category-hover:hover img {\n  transform: scale(1.1);\n}\n\n.table-body-checkbox {\n  height: 55px;\n}\n\n/* ── Sticky Table Columns ── */\nth.sticky-table-header,\n.sticky-table-header {\n  position: sticky !important;\n  background-color: #F4F4F5 !important;\n  z-index: 25 !important;\n}\n\n.dark-mode th.sticky-table-header,\n.dark-mode .sticky-table-header {\n  background-color: var(--primary-bg-color, #1a1a1a) !important;\n}\n\ntd.sticky-table-cell,\n.sticky-table-cell {\n  position: sticky !important;\n  background-color: #FAFAFA !important;\n  z-index: 15 !important;\n}\n\n.dark-mode td.sticky-table-cell,\n.dark-mode .sticky-table-cell {\n  background-color: var(--secondary-bg-color, #242424) !important;\n}\n\ntable tbody tr:hover td.sticky-table-cell,\ntable tbody tr:hover .sticky-table-cell {\n  background-color: #F4F4F5 !important;\n}\n\n.dark-mode table tbody tr:hover td.sticky-table-cell,\n.dark-mode table tbody tr:hover .sticky-table-cell {\n  background-color: var(--focus-tab-color, #2e2e2e) !important;\n}\n\ntable tbody tr.selected-row td.sticky-table-cell,\ntable tbody tr.selected-row:hover td.sticky-table-cell,\ntable tbody tr.selected-row .sticky-table-cell,\ntable tbody tr.selected-row:hover .sticky-table-cell {\n  background-color: rgba(var(--primary-bg-color-rgb, 244, 246, 248), 70%) !important;\n}\n\n.dark-mode table tbody tr.selected-row td.sticky-table-cell,\n.dark-mode table tbody tr.selected-row:hover td.sticky-table-cell,\n.dark-mode table tbody tr.selected-row .sticky-table-cell,\n.dark-mode table tbody tr.selected-row:hover .sticky-table-cell {\n  background-color: var(--sidebar-bg-color, #0d0d0d) !important;\n}\n\n.sticky-shadow-left {\n  box-shadow: 6px 0 10px -2px rgba(0, 0, 0, 0.12) !important;\n  border-right: 1px solid var(--border-color) !important;\n}\n\n.sticky-shadow-right {\n  box-shadow: -6px 0 10px -2px rgba(0, 0, 0, 0.12) !important;\n  border-left: 1px solid var(--border-color) !important;\n}\n\n.dark-mode .sticky-shadow-left {\n  box-shadow: 6px 0 10px -2px rgba(0, 0, 0, 0.4) !important;\n}\n\n.dark-mode .sticky-shadow-right {\n  box-shadow: -6px 0 10px -2px rgba(0, 0, 0, 0.4) !important;\n}\n\n.add-discount-table table thead tr td:last-child,\n.add-discount-table table tbody tr td:last-child {\n  position: sticky !important;\n  right: 0 !important;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  /* width: 200px; */\n  /* background-color: inherit; */\n  z-index: 5;\n}\n\n.css-1t1j96h-MuiPaper-root-MuiDialog-paper {\n  max-width: 700px !important;\n  margin: 10px !important;\n}\n\n.react-datepicker__time-container {\n  width: auto !important;\n}\n\n.schdule-time .react-datepicker-popper {\n  position: relative !important;\n  transform: translate(0, 0) !important;\n}\n\n.filter-btn {\n  background-color: var(--secondary-bg-color);\n  border: 1px solid var(--border-color);\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-sm);\n  transition: all 0.15s ease;\n  font-size: 13px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: var(--shadow-card);\n}\n\n.filter-btn:hover {\n  background-color: var(--focus-tab-color) !important;\n  border-color: var(--focus-border-color) !important;\n}\n\n.dark-mode .filter-btn:hover {\n  background-color: var(--primary-bg-color) !important;\n  border-color: var(--focus-border-color) !important;\n}\n\n.filter-btn svg {\n  width: 16px;\n  height: 16px;\n  color: var(--table-text-color);\n}\n\n.slug-edit {\n  position: absolute;\n  right: 4px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.gocYik {\n  background-color: rgba(var(--primary-bg-color-rgb), 70%) !important;\n  color: var(--btn-bg-primary);\n  font-weight: 600;\n  min-height: 40px !important;\n  font-size: 12px;\n  border: none !important;\n  /* border-bottom: 1px solid var(--border-color) !important; */\n}\n\n.dark-mode .gocYik {\n  color: var(--table-text-color) !important;\n}\n\n.admin-search .MuiPaper-root.MuiPaper-elevation {\n  left: 50% !important;\n  top: 5% !important;\n  transform: translateX(-50%) !important;\n}\n\ndetails {\n  padding: 0px !important;\n  background-color: var(--secondary-bg-color) !important;\n}\n\ndetails summary {\n  padding: 25px !important;\n  position: relative;\n}\n\n.theme-setting details summary {\n  padding: 15px !important;\n}\n\n:not(.editor-details)details[open] summary::after {\n  content: '';\n  top: 100%;\n  left: 0;\n  position: absolute;\n  width: 95%;\n  height: 1px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--border-color);\n  margin-bottom: 25px;\n}\n\ndetails>div {\n  padding: 0px 25px 0px 25px !important;\n}\n\n.editor-details details>div {\n  padding: 0 !important;\n}\n\n.editor-heading {\n  font-size: 14px !important;\n}\n\n.editor-title {\n  font-size: 12px !important;\n}\n\n.hover-icon path {\n  stroke: #555555;\n}\n\n.select-container {\n  background-color: #f6f6f6 !important;\n  border: none !important;\n}\n\n.hover-icon:hover path {\n  stroke: #ffffff;\n}\n\n.editor-details details>div:last-child {\n  padding: 0 !important;\n}\n\n.editor-details details>div {\n  padding: 0 !important;\n}\n\n.editor-heading {\n  font-size: 14px !important;\n}\n\n.editor-title {\n  font-size: 12px !important;\n}\n\n.hover-icon path {\n  stroke: #555555;\n}\n\n.select-container {\n  background-color: #f6f6f6 !important;\n  border: none !important;\n}\n\n.hover-icon:hover path {\n  stroke: #ffffff;\n}\n\n.editor-details details>div:last-child {\n  padding: 0 !important;\n}\n\n.theme-setting details summary {\n  appearance: none !important;\n}\n\n.theme-setting details>div {\n  padding: 0px 15px 0px 15px !important;\n}\n\n/* details hr {\n  display: none !important;\n} */\n\ndetails>div:last-child {\n  padding-bottom: 25px !important;\n}\n\n.theme-setting details>div:last-child {\n  padding-bottom: 15px !important;\n}\n\ndetails>div:first-child {\n  padding: 25px 25px 0px 25px !important;\n}\n\ndetails>button:last-child {\n  margin-bottom: 25px !important;\n  margin-left: 25px !important;\n}\n\n.checkbox {\n  opacity: 0;\n  position: absolute;\n}\n\n.checkbox-label {\n  background-color: #111;\n  width: 50px;\n  height: 26px;\n  border-radius: 50px;\n  position: relative;\n  padding: 5px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.checkbox-label .ball {\n  background-color: #fff;\n  width: 22px;\n  height: 22px;\n  position: absolute;\n  left: 2px;\n  top: 2px;\n  border-radius: 50%;\n  transition: transform 0.2s linear;\n}\n\n.checkbox:checked+.checkbox-label .ball {\n  transform: translateX(24px);\n}\n\n.dark-mode-toggle input[type='checkbox'] {\n  position: absolute !important;\n}\n\n.dark-mode-toggle .MuiSwitch-thumb {\n  background-color: var(--sidebar-bg-color) !important;\n}\n\n.dark-mode .dark-mode-toggle .MuiSwitch-track {\n  background-color: var(--table-text-color) !important;\n}\n\n.subscription-line {\n  background: #222;\n}\n\n.adminsearch {\n  background-color: rgba(var(--primary-bg-color-rgb), 70%);\n}\n\n/* .dark-mode .subscription-line {\n  background-color: var(--secondary-bg-color);\n  border-color: var(--border-color) !important;\n} */\n\n.metaFieldgroup>ul {\n  padding: 10px;\n  background-color: var(--secondary-bg-color);\n  border-radius: 4px;\n}\n\n.metaFieldgroup>ul>li {\n  padding: 7px 15px;\n  font-size: 15px;\n  text-transform: capitalize;\n  width: 100%;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.metaFieldgroup>ul>li:hover {\n  background-color: var(--primary-bg-color);\n  color: var(--primary-text-color) !important;\n  cursor: pointer;\n}\n\n.selected-brand {\n  border: 2px solid #2c6ecb;\n}\n\n.hover-border:hover {\n  border: 2px solid #3b82f6;\n}\n\n.bg-gray-100 {\n  background-color: #f0f0f0;\n}\n\n.default-border {\n  border: 2px solid transparent;\n  transition: border-color 0.3s ease;\n}\n\n.selected-border {\n  border: 2px solid #3b82f6;\n  /* Color for selected section */\n}\n\n.page_builder_container {\n  border: 2px solid transparent;\n  /* Default transparent border */\n}\n\n.page_builder_container:hover {\n  border: 2px solid transparent;\n  /* Transparent border on hover */\n}\n\n.page_builder_container.selected {\n  border: 2px solid #2c6ecb;\n  /* Blue border for selected section */\n}\n\n.hover-border {\n  border: 2px solid transparent;\n  /* Default border is transparent */\n  transition: border 0.2s ease-in-out;\n}\n\n.hover-border:hover {\n  border: 2px solid #3b82f6;\n  /* Border color on hover */\n}\n\n.product-name-div {\n  border: 2px solid transparent;\n  transition: border 0.3s ease;\n}\n\n.product-name-div:hover {\n  border: 2px solid #3b82f6;\n}\n\n.active-border {\n  border: 2px solid #3b82f6;\n}\n\n/* .hover-border {\n    transition: border 0.3s ease;\n} */\n\n.hover-border:hover {\n  border: 2px solid #3b82f6;\n}\n\n.parent-hover:hover .child-hover {\n  background-color: #6f7a86;\n}\n\n.element-title {\n  font-size: 12px;\n}\n\n.metaFieldgroupCustome>ul {\n  padding: 10px;\n  background-color: var(--secondary-bg-color);\n  border-radius: 4px;\n}\n\n.metaFieldgroupCustome>ul>li {\n  padding: 7px 15px;\n  font-size: 15px;\n  text-transform: capitalize;\n  width: 100%;\n  border-radius: 4px;\n  display: flex;\n}\n\n.metaFieldgroupCustome>ul>li:hover {\n  background-color: var(--primary-bg-color);\n  color: var(--primary-text-color) !important;\n  cursor: pointer;\n}\n\n.bg-radio-button input {\n  font-size: 15px !important;\n}\n\n.dark-mode .MuiBox-root,\n.dark-mode .lucide {\n  color: var(--primary-text-color) !important;\n  background-color: var(--secondary-bg-color) !important;\n  border-color: var(--border-color) !important;\n}\n\n.dark-mode .MuiBox-root:hover,\n.dark-mode .lucide:hover {\n  color: var(--primary-text-color) !important;\n  border-color: var(--border-color) !important;\n}\n\n.dark-mode .lucide:hover {\n  background-color: var(--primary-bg-color) !important;\n}\n\n/* Pagination Dark Mode Wrapper Overrides */\n.dark-mode div.bg-white:has(> .pagination-container) {\n  background-color: var(--secondary-bg-color) !important;\n}\n\n/* ============================================================\n   GLOBAL FONT APPLICATION\n   ============================================================ */\nbody,\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: var(--font-sans) !important;\n}\n\n/* ============================================================\n   GLOBAL BTN UTILITY CLASS  (backward-compat with old .btn usage)\n   ============================================================ */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 9px 16px;\n  font-size: 13.5px;\n  font-weight: 500;\n  font-family: var(--font-sans);\n  border-radius: var(--radius-sm);\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  user-select: none;\n  white-space: nowrap;\n  background-color: var(--btn-bg-primary);\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n}\n\n.btn:hover:not(:disabled) {\n  background-color: var(--bg-btn-hover);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.btn:active:not(:disabled) {\n  transform: translateY(1px);\n  box-shadow: none;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── Input Base Utility ── */\n.input-base {\n  width: 100%;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background-color: var(--secondary-bg-color);\n  color: var(--primary-text-color);\n  font-size: 13.5px;\n  font-family: var(--font-sans);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  outline: none;\n}\n\n.input-base::placeholder {\n  color: var(--table-text-color);\n  opacity: 0.8;\n}\n\n.input-base:hover {\n  border-color: var(--focus-border-color);\n}\n\n.input-base:focus {\n  border-color: var(--focus-border-color) !important;\n  box-shadow: 0 0 0 3px rgba(var(--focus-border-color-rgb), 0.12);\n}\n\n.input-base--error {\n  border-color: var(--color-danger) !important;\n  box-shadow: 0 0 0 3px rgba(215, 44, 13, 0.1) !important;\n}\n\n.input-help-text {\n  font-size: 12px;\n  color: var(--table-text-color);\n  margin-top: 4px;\n}\n\n.input-error-text {\n  font-size: 12px;\n  color: var(--color-danger);\n  margin-top: 4px;\n  font-weight: 500;\n}\n\n/* ── Status Badge System ── */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: var(--font-sans);\n  white-space: nowrap;\n}\n\n.badge-success {\n  background-color: var(--color-success-bg);\n  color: var(--color-success);\n}\n\n.badge-warning {\n  background-color: var(--color-warning-bg);\n  color: var(--color-warning);\n}\n\n.badge-danger {\n  background-color: var(--color-danger-bg);\n  color: var(--color-danger);\n}\n\n.badge-info {\n  background-color: var(--color-info-bg);\n  color: var(--color-info);\n}\n\n.badge-neutral {\n  background-color: var(--focus-tab-color);\n  color: var(--table-text-color);\n}\n\n/* ============================================================\n   PAGINATION COMPONENT\n   ============================================================ */\n.pagination-container {\n  background-color: var(--secondary-bg-color);\n  border-top: 1px solid var(--border-color);\n  border-radius: 0 0 var(--radius-md) var(--radius-md);\n}\n\n.dark-mode .pagination-container {\n  background-color: var(--secondary-bg-color);\n  border-top-color: var(--border-color);\n}\n\n.dark-mode div.bg-white:has(> .pagination-container) {\n  background-color: var(--secondary-bg-color) !important;\n}\n\n/* ============================================================\n   SELECT COMPONENT SYSTEM\n   All colors use CSS variables — dark/light mode is automatic.\n   Never write manual select CSS in any page/component file.\n   ============================================================ */\n\n/* ── Label ── */\n.select-label {\n  color: var(--primary-text-color);\n}\n\n/* ── Trigger Button (the visible \"select box\") ── */\n.select-trigger {\n  background-color: var(--secondary-bg-color);\n  border-color: var(--border-color);\n  color: var(--primary-text-color);\n  font-family: var(--font-sans);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n}\n\n/* Hover state — subtle background shift */\n.select-trigger:not(.select-trigger--disabled):hover {\n  background-color: var(--focus-tab-color);\n  border-color: var(--focus-border-color);\n}\n\n/* Open / active state — focused ring + accent border */\n.select-trigger--open {\n  border-color: var(--focus-border-color) !important;\n  box-shadow: 0 0 0 3px rgba(var(--focus-border-color-rgb), 0.12);\n  background-color: var(--secondary-bg-color) !important;\n}\n\n/* Error state */\n.select-trigger--error {\n  border-color: var(--color-danger) !important;\n  box-shadow: 0 0 0 3px rgba(215, 44, 13, 0.1) !important;\n}\n\n/* Placeholder text color */\n.select-trigger--empty .select-trigger-placeholder,\n.select-trigger--empty>div>span {\n  color: var(--table-text-color);\n  opacity: 0.85;\n}\n\n/* Disabled / loading */\n.select-trigger--disabled {\n  background-color: var(--focus-tab-color) !important;\n  cursor: not-allowed !important;\n  opacity: 0.6;\n}\n\n/* Caret / arrow icon */\n.select-arrow-icon {\n  color: var(--table-text-color);\n  flex-shrink: 0;\n  opacity: 0.7;\n}\n\n/* Spinner icon */\n.select-icon {\n  color: var(--table-text-color);\n}\n\n/* Clear (×) button inside trigger */\n.select-clear-btn {\n  color: var(--table-text-color);\n  opacity: 0.7;\n  border-radius: 50%;\n  transition: all 0.15s ease;\n}\n\n.select-clear-btn:hover {\n  background-color: var(--focus-tab-color);\n  color: var(--primary-text-color);\n  opacity: 1;\n}\n\n/* ── Tag chips for multi-select — Shopify pill style ── */\n.select-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px 2px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 20px;\n  user-select: none;\n  background-color: var(--focus-tab-color);\n  color: var(--primary-text-color);\n  border: 1px solid var(--border-color);\n  font-family: var(--font-sans);\n  transition: all 0.1s ease;\n}\n\n.select-chip:hover {\n  background-color: var(--primary-bg-color);\n}\n\n.select-chip-remove {\n  color: var(--table-text-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.15s;\n  border-radius: 50%;\n  padding: 1px;\n}\n\n.select-chip-remove:hover {\n  color: var(--color-danger);\n  background-color: rgba(215, 44, 13, 0.08);\n}\n\n/* ── Popover Paper ── */\n.select-popover-paper {\n  background-color: var(--secondary-bg-color) !important;\n  border: 1px solid var(--border-color) !important;\n  border-radius: var(--radius-md) !important;\n  box-shadow: var(--shadow-popover) !important;\n  overflow: hidden;\n}\n\n.dark-mode .select-popover-paper {\n  box-shadow:\n    0 20px 30px -8px rgba(0, 0, 0, 0.5),\n    0 6px 10px -3px rgba(0, 0, 0, 0.35) !important;\n}\n\n/* ── Search input inside popover ── */\n.select-search-wrap {\n  border-color: var(--border-color);\n}\n\n.select-search-input {\n  background-color: var(--primary-bg-color);\n  border-color: var(--border-color);\n  color: var(--primary-text-color);\n}\n\n.select-search-input::placeholder {\n  color: var(--table-text-color);\n}\n\n.select-search-input:focus {\n  border-color: var(--focus-border-color) !important;\n  box-shadow: none;\n}\n\n.select-search-clear {\n  color: var(--table-text-color);\n}\n\n.select-search-clear:hover {\n  color: var(--primary-text-color);\n}\n\n/* ── \"Clear Selection\" row ── */\n.select-option-clear {\n  color: var(--table-text-color);\n}\n\n.select-option-clear:hover {\n  background-color: var(--primary-bg-color);\n  color: var(--primary-text-color);\n}\n\n/* ── Option rows ── */\n.select-option {\n  color: var(--primary-text-color);\n  font-family: var(--font-sans);\n  transition: background-color 0.1s ease;\n  border-radius: 0;\n}\n\n/* Default (un-selected, un-highlighted) hover */\n.select-option--default:hover {\n  background-color: var(--focus-tab-color);\n}\n\n/* Keyboard highlighted (ArrowUp / ArrowDown) */\n.select-option--highlighted {\n  background-color: var(--focus-tab-color);\n  color: var(--primary-text-color);\n}\n\n/* Selected option — Shopify uses a subtle background, not full dark */\n.select-option--selected {\n  background-color: var(--focus-tab-color);\n  color: var(--primary-text-color);\n  font-weight: 600;\n}\n\n.select-option--selected:hover {\n  background-color: var(--primary-bg-color);\n}\n\n/* Check icon shown next to selected option */\n.select-check-icon {\n  color: var(--btn-bg-primary);\n}\n\n.dark-mode .select-check-icon {\n  color: var(--primary-text-color);\n}\n\n/* ── Multi-select checkbox ── */\n.select-checkbox {\n  border-color: var(--border-color);\n  background-color: var(--secondary-bg-color);\n  color: transparent;\n  border-radius: 4px;\n  transition: all 0.12s ease;\n}\n\n.select-checkbox--unchecked {\n  border-color: #E4E4E7 !important;\n}\n\n.select-checkbox--unchecked:hover {\n  border-color: var(--focus-border-color);\n}\n\n.select-checkbox--checked {\n  background-color: var(--btn-bg-primary);\n  border-color: var(--btn-bg-primary);\n  color: #ffffff;\n}\n\n/* ── Empty state ── */\n.select-empty {\n  color: var(--table-text-color);\n}\n\n/* ============================================================\n   SEARCH COMPONENT SYSTEM\n   ============================================================ */\n.search-component-input {\n  background-color: var(--secondary-bg-color) !important;\n  border: 1px solid var(--border-color) !important;\n  color: var(--primary-text-color) !important;\n  font-family: var(--font-sans);\n  font-size: 13.5px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n}\n\n.search-component-input::placeholder {\n  color: var(--table-text-color) !important;\n  opacity: 0.8;\n}\n\n.search-component-input:hover {\n  border-color: var(--focus-border-color) !important;\n}\n\n.search-component-input:focus {\n  border-color: var(--focus-border-color) !important;\n  box-shadow: 0 0 0 2.5px rgba(var(--focus-border-color-rgb), 0.15) !important;\n  background-color: var(--secondary-bg-color) !important;\n}\n\n.search-component-clear-btn {\n  color: var(--table-text-color);\n  opacity: 0.7;\n  border-radius: 50%;\n  padding: 2px;\n  transition: all 0.15s ease;\n}\n\n.search-component-clear-btn:hover {\n  background-color: var(--focus-tab-color);\n  color: var(--primary-text-color);\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
